export const includedInArray = (checkArray: any[], arrayToBeChecked: any[]) =>
  checkArray.some((value) => arrayToBeChecked.includes(value));
